"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FGuestService = void 0;
const __1 = require("../../..");
const domain_1 = require("../../../domain");
const mappers_1 = require("../mappers");
class FGuestService {
    constructor(apolloClient) {
        this.apolloClient = apolloClient;
    }
    getGuestPaymentProfile(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const paymentProfileMapper = new mappers_1.PaymentProfileMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.GET_GUEST_PAYMENT_PROFILE,
                    variables,
                });
                if (variables.callbak)
                    variables.callbak();
                return Promise.resolve(paymentProfileMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.GuestServiceErrors.GetGuestPaymentProfileRequestError("GET_GUEST_PAYMENT_PROFILE_REQUEST_FAILED", error));
            }
        });
    }
}
exports.FGuestService = FGuestService;
